import React, { createContext, useContext, useState } from 'react'
import { ContactSlugEnum } from 'src/shared/enums/contact-fields-enum'

export type FieldsValuesType = Partial<Record<ContactSlugEnum, string>>
type CheckboxesValuesType = Record<string, boolean>
export type FieldsErrorsType = Partial<Record<ContactSlugEnum, string[]>>
export type CheckboxesErrorsType = Record<string, string>
type CommonErrorsType = string[]

interface FormContextInterface {
  fieldsValues: FieldsValuesType
  setFieldsValues: React.Dispatch<React.SetStateAction<FieldsValuesType>>
  checkboxesValues: CheckboxesValuesType
  setCheckboxesValues: React.Dispatch<
    React.SetStateAction<CheckboxesValuesType>
  >
  fieldsErrors: FieldsErrorsType
  setFieldsErrors: React.Dispatch<React.SetStateAction<FieldsErrorsType>>
  checkboxesErrors: CheckboxesErrorsType
  setCheckboxesErrors: React.Dispatch<
    React.SetStateAction<CheckboxesErrorsType>
  >
  commonErrors: string[]
  setCommonErrors: React.Dispatch<React.SetStateAction<string[]>>
}

const FormContext = createContext<FormContextInterface>({
  fieldsValues: {},
  setFieldsValues: () => ({}),
  checkboxesValues: {},
  setCheckboxesValues: () => ({}),
  fieldsErrors: {},
  setFieldsErrors: () => ({}),
  checkboxesErrors: {},
  setCheckboxesErrors: () => ({}),
  commonErrors: [],
  setCommonErrors: () => [],
})

export const useFormContext = () => useContext(FormContext)

export const FormProvider = (props: React.PropsWithChildren) => {
  const [fieldsValues, setFieldsValues] = useState<FieldsValuesType>({})
  const [checkboxesValues, setCheckboxesValues] =
    useState<CheckboxesValuesType>({})
  const [fieldsErrors, setFieldsErrors] = useState<FieldsErrorsType>({})
  const [checkboxesErrors, setCheckboxesErrors] =
    useState<CheckboxesErrorsType>({})
  const [commonErrors, setCommonErrors] = useState<CommonErrorsType>([])

  return (
    <FormContext.Provider
      value={{
        fieldsValues,
        setFieldsValues,
        checkboxesValues,
        setCheckboxesValues,
        fieldsErrors,
        setFieldsErrors,
        checkboxesErrors,
        setCheckboxesErrors,
        commonErrors,
        setCommonErrors,
      }}
    >
      {props.children}
    </FormContext.Provider>
  )
}
